export const getCaseStatusColor = (c) => {
    if (c?.completeBy) return 'rgba(56,142,60,0.7)'
    if (c?.modalityWorklist) return 'rgba(25,118,210,0.7)'
    if (c?.instanceCount > 0) return 'rgba(255,167,38,0.7)'
    return 'rgba(80,80,80,0.85)'
}
